import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_ELERING_EDIT } from '../../constants/formKeys';
import {
  getClassifiersEleringChange,
  getClassifiersEleringItem,
  getClassifiersEleringItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { elering } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterEleringTitle',
  formKey: FORM_CLASSIFIERS_ELERING_EDIT,
  fields: [
    {
      name: elering.NAME,
      label: 'fieldName',
      component: TextField,
      colSpan: 12,
    },
    {
      name: elering.REGISTRY_CODE,
      label: 'fieldRegistryCode',
      component: TextField,
      colSpan: 12,
    },
    {
      name: elering.KMKR_CODE,
      label: 'fieldKmkr',
      component: TextField,
      colSpan: 12,
    },
    {
      name: elering.BANK_ACCOUNT,
      label: 'fieldBankAccount',
      component: TextField,
      colSpan: 12,
    },
  ],
  fetchAction: actions.fetchClassifierElering,
  changeAction: actions.changeClassifierElering,
  getChangeSelector: getClassifiersEleringChange,
  getItemSelector: getClassifiersEleringItem,
  getInitialValues: (state) => getClassifiersEleringItemData(state)?.toJS(),
});
